import { Button, Group, Modal, Stack, Text, useMantineTheme } from '@mantine/core'
import { IconAlertCircle } from '@tabler/icons-react'

interface SponsorSwitchConfirmationModalProps {
  opened: boolean
  onClose: () => void
  onConfirm: () => void
  sponsorName: string
}

export function SponsorSwitchConfirmationModal({
  opened,
  onClose,
  onConfirm,
  sponsorName,
}: SponsorSwitchConfirmationModalProps) {
  const theme = useMantineTheme()
  const trimmedSponsorName = sponsorName.trim()
  return (
    <Modal.Root opened={opened} onClose={onClose} centered size="md">
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <IconAlertCircle
            size={24}
            style={{ minWidth: 24, color: 'var(--mantine-color-yellow-6)', marginRight: theme.spacing.xs }}
          />
          <Modal.Title fw={600}>Switch Channel</Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body pt="xs">
          <Stack gap="xl">
            <Text>
              Are you sure you want to switch to{' '}
              <Text span style={{ whiteSpace: 'nowrap' }}>
                <strong>{trimmedSponsorName}</strong>?
              </Text>{' '}
              This will reload the application with data from the new channel.
            </Text>

            <Group justify="flex-end" gap="sm">
              <Button variant="default" onClick={onClose}>
                Cancel
              </Button>
              <Button onClick={onConfirm}>Switch Channel</Button>
            </Group>
          </Stack>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  )
}
